import { twMerge } from 'tailwind-merge';

import { Link, LinkProps } from '@/components/Link';

export type AccountMenuItemProps = LinkProps;

export function AccountMenuItem({ className, ...props }: AccountMenuItemProps) {
  return (
    <Link
      className={twMerge(
        'px-4 py-2 text-left',
        'hover:text-zmyle-primary hover:bg-gray-50 hover:no-underline',
        className,
      )}
      target="_self"
      {...props}
    />
  );
}
